import { render, staticRenderFns } from "./DetalleAgendamientoObservaciones.vue?vue&type=template&id=e0727bd8&"
import script from "./DetalleAgendamientoObservaciones.vue?vue&type=script&lang=js&"
export * from "./DetalleAgendamientoObservaciones.vue?vue&type=script&lang=js&"
import style0 from "./DetalleAgendamientoObservaciones.vue?vue&type=style&index=0&id=e0727bd8&prod&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports